// src/pages/Telegram.jsx
import React, { useState } from 'react';

const TELEGRAM_ENDPOINT = 'https://marketbusters.pro/telegram/enviar_telegram_grupo2.php';
const TELEGRAM_GROUP_ID = '-1002583737824';

export default function Telegram() {
  const [message, setMessage] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState(null);

  /* —— Estilos —— */
  const layout = {
    display: 'flex',
    gap: '20px',
    maxWidth: '900px',
    margin: '0 auto',
    padding: '20px',
    flexWrap: 'wrap',
    alignItems: 'center',
    minHeight: '80vh',
  };
  const formBox = { flex: '1 1 320px' };
  const phoneStyle = {
    width: '360px',
    height: '640px',
    border: '1px solid #ccc',
    borderRadius: '20px',
    overflow: 'hidden',
    boxShadow: '0 0 10px rgba(0,0,0,0.2)',
    backgroundColor: '#fff',
    flexShrink: 0,
  };
  const screenStyle = {
    padding: '10px',
    height: '100%',
    overflowY: 'auto',
    backgroundColor: '#e5ddd5',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  };
  const imageStyle = { maxWidth: '100%', borderRadius: '10px', marginBottom: '10px' };

  const handleFileChange = (e) => {
    const file = e.target.files && e.target.files[0];
    if (file) {
      setSelectedFile(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async () => {
    if (!message && !selectedFile) return;
    setLoading(true);

    const formData = new FormData();
    formData.append('chatId', TELEGRAM_GROUP_ID);
    formData.append('caption', message || '');

    // Detectar tipo y usar key adecuada
    if (selectedFile) {
      if (selectedFile.type.startsWith('image/')) {
        formData.append('photo', selectedFile);
      } else if (selectedFile.type.startsWith('video/')) {
        formData.append('video', selectedFile);
      } else {
        formData.append('document', selectedFile);
      }
    }

    try {
      const res = await fetch(TELEGRAM_ENDPOINT, { method: 'POST', body: formData });
      const data = await res.json();
      setResponse(data);
      if (data.success) {
        setMessage('');
        setSelectedFile(null);
        setPreviewUrl('');
      }
    } catch (err) {
      setResponse({ success: false, error: err.message });
    }
    setLoading(false);
  };

  return (
    <div style={layout}>
      {/* —— Columna izquierda: formulario —— */}
      <div style={formBox}>
        <h2>Telegram</h2>
        <div style={{ marginBottom: '10px' }}>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Escribe tu mensaje..."
            rows={4}
            style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ccc' }}
          />
          <input
            type="file"
            accept="image/*,video/mp4,application/pdf,*/*"
            onChange={handleFileChange}
            style={{ marginTop: '10px' }}
          />
        </div>
        <button
          onClick={handleSubmit}
          disabled={loading}
          style={{
            width: '100%',
            padding: '12px',
            border: 'none',
            borderRadius: '5px',
            backgroundColor: '#0088cc',
            color: '#fff',
            fontSize: '16px',
            cursor: 'pointer',
          }}
        >
          {loading ? 'Enviando…' : 'Enviar'}
        </button>
        {response && (
          <div style={{ marginTop: '10px', color: response.success ? 'green' : 'red' }}>
            {response.success ? 'Mensaje enviado correctamente' : `Error: ${response.error}`}
          </div>
        )}
      </div>

      {/* —— Columna derecha: vista previa —— */}
      <div style={{ flex: '1 1 360px', display: 'flex', justifyContent: 'center' }}>
        <div style={phoneStyle}>
          <div style={screenStyle}>
            {previewUrl && selectedFile && selectedFile.type.startsWith('video/') && (
              <video src={previewUrl} controls style={imageStyle} />
            )}
            {previewUrl && selectedFile && !selectedFile.type.startsWith('video/') && (
              <img src={previewUrl} alt="Preview" style={imageStyle} />
            )}
            {message && (
              <p style={{ background: '#dcf8c6', padding: '8px 12px', borderRadius: '18px', maxWidth: '80%' }}>
                {message}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}